import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DataRequest, DocumentRequest } from '../../_models/configuration.model';

@Component({
  selector: 'app-data-section-settings',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './data-section-settings.component.html',
  styleUrls: ['./data-section-settings.component.scss']
})
export class DataSectionSettingsComponent {
  @Input() dataRequest: DataRequest[] = [];
  @Input() documentRequest: DocumentRequest[] = [];
  @Input() dataRequestStatus: { [fieldId: string]: 'required' | 'optional' | 'not_used' } = {};
  @Input() documentStatus: { [docId: string]: 'required' | 'optional' | 'not_used' } = {};

  @Output() dataRequestStatusChange = new EventEmitter<{ [fieldId: string]: 'required' | 'optional' | 'not_used' }>();
  @Output() documentStatusChange = new EventEmitter<{ [docId: string]: 'required' | 'optional' | 'not_used' }>();

  /**
   * Establece el estado de un campo de datos (dataRequest)
   */
  setDataRequestStatus(fieldId: string, status: 'required' | 'optional' | 'not_used'): void {
    this.dataRequestStatus[fieldId] = status;
    this.dataRequestStatusChange.emit(this.dataRequestStatus);
  }

  /**
   * Establece el estado de un documento (documentRequest)
   */
  setDocumentStatus(docId: string, status: 'required' | 'optional' | 'not_used'): void {
    this.documentStatus[docId] = status;
    this.documentStatusChange.emit(this.documentStatus);
  }

  /**
   * Obtiene los documentos filtrados por sectionId
   */
  getDocumentsForSection(sectionId: string): DocumentRequest[] {
    return this.documentRequest.filter(doc => doc.sectionCardId === sectionId);
  }

  /**
   * Obtiene los campos de datos filtrados por sectionId
   */
  getDataFieldsForSection(sectionId: string): DataRequest[] {
    return this.dataRequest.filter(field => field.sectionCardId === sectionId);
  }
}
